import { useEnvironment } from 'src/env/EnvironmentStore'
import { ReactNode, useEffect } from 'react'
import { LicenseInfo } from '@mui/x-license'

export const MUILicenseLoader = ({ children }: { children: ReactNode }) => {
  const { materialUiLicenseKey } = useEnvironment()

  // load mui license from env
  useEffect(() => {
    if (materialUiLicenseKey !== '' && materialUiLicenseKey !== undefined && materialUiLicenseKey !== null) {
      LicenseInfo.setLicenseKey(materialUiLicenseKey)
    }
  }, [materialUiLicenseKey])

  return children
}
